/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantRoleItemDto } from './tenantRoleItemDto';
import { AttachmentDetailDto } from './attachmentDetailDto';
import { TenantItemDto } from './tenantItemDto';
import { UserPermissions } from './userPermissions';


export interface UserDetailDto { 
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    abbreviation: string;
    tenant: TenantItemDto;
    userProfilePicture?: AttachmentDetailDto;
    autoSave: boolean;
    tenantType: UserDetailDto.TenantTypeEnum;
    permissions: UserPermissions;
    roles: Array<TenantRoleItemDto>;
    enableMaintenanceNotifications: boolean;
    phoneNumber?: string;
    mobileNumber?: string;
    hasQrPin: boolean;
    qrPinCreated?: string;
}
export namespace UserDetailDto {
    export type TenantTypeEnum = 'Internal' | 'External' | 'Contractor';
    export const TenantTypeEnum = {
        Internal: 'Internal' as TenantTypeEnum,
        External: 'External' as TenantTypeEnum,
        Contractor: 'Contractor' as TenantTypeEnum
    };
}


